import { post } from '../api';

/**
 * Fase 2 (W3, ficha de PWA): service worker e inscrição no Web Push. A permissão só é pedida a partir de um clique
 * (exigência do Safari e boa prática). No iPhone, o push só existe com o app instalado na tela de início (iOS 16.4+).
 */
export type SuportePush = 'sim' | 'nao' | 'ios_instalar' | 'negado';

export function suportePush(nav: Pick<Navigator, 'userAgent'> & { standalone?: boolean } = navigator, w: Partial<Window> = window): SuportePush {
  const ios = /iPhone|iPad|iPod/.test(nav.userAgent);
  const instalado = nav.standalone === true || w.matchMedia?.('(display-mode: standalone)').matches === true;
  if (ios && !instalado) return 'ios_instalar';
  if (!('serviceWorker' in (nav as Navigator)) || !('PushManager' in w) || !('Notification' in w)) return 'nao';
  return Notification.permission === 'denied' ? 'negado' : 'sim';
}

export function registrarServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
}

const daBase64Url = (s: string) => Uint8Array.from(atob(s.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0));

/** Nome amigável do aparelho (sistema e navegador), sem identificador único. */
export function nomeDoAparelho(ua: string = navigator.userAgent) {
  const so = /iPhone|iPad/.test(ua) ? 'iOS' : /Android/.test(ua) ? 'Android' : /Mac OS X/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : 'Linux';
  const nav = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : '';
  return [so, nav].filter(Boolean).join(' ');
}

/** Pede a permissão, inscreve e registra o aparelho na conta. Devolve o motivo quando não deu. */
export async function ativarPush(chavePublica: string): Promise<'ok' | 'negado' | 'erro'> {
  if ((await Notification.requestPermission()) !== 'granted') return 'negado';
  const reg = await navigator.serviceWorker.ready;
  const inscricao = (await reg.pushManager.getSubscription()) ?? (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: daBase64Url(chavePublica) }));
  const j = inscricao.toJSON() as { endpoint?: string; keys?: { p256dh?: string; auth?: string } };
  if (!j.endpoint || !j.keys?.p256dh || !j.keys.auth) return 'erro';
  await post('/notificacoes/dispositivos', { id: crypto.randomUUID(), endpoint: j.endpoint, p256dh: j.keys.p256dh, auth: j.keys.auth, nome: nomeDoAparelho() });
  return 'ok';
}
